namespace $ {

	export function $shm_hitalama_map_widget_markdown_title( text: string ) {
		const first = text.split( /\r?\n/, 1 )[0]
		return /^ {0,3}#{1,6}[ \t]+(.+)$/.exec( first )?.[1]?.replace( /[ \t]+#+[ \t]*$/, '' ).trim() ?? ''
	}

	export function $shm_hitalama_map_widget_visible( widget: $shm_hitalama_map_widget ) {
		return true
	}

	class Widget_def_type extends $giper_baza_atom.of( $mol_schema_enum( $shm_hitalama_map_widget_def_types ) ){}
	class Widget_type_custom extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_custom ){}
	class Widget_map extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map ){}
	class Widget_widgets extends $giper_baza_list_link.to( ()=> $giper_baza_entity ){}
	class Widget_inside_widget extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_text_crdt extends $giper_baza_atom_link.to( ()=> $giper_baza_text ){}
	class Widget_text_file extends $giper_baza_atom_link.to( ()=> $shm_hitalama_file ){}
	class Widget_use_text_from extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_settings_widget extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_controlled_widget extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_view_widget extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_code_widget extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_ai_request extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_ai_request ){}
	class Widget_component extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_component ){}
	class Widget_form extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_form ){}
	class Widget_form_custom extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_form_custom ){}
	class Widget_table extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table ){}
	class Widget_dataset extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table2_dataset ){}
	class Widget_entity_field extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table2_field ){}
	class Widget_entity_owner extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ){}
	class Widget_record2 extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table2_record ){}
	class Widget_relation_source_record extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table2_record ){}
	class Widget_relation_source_field extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table2_field ){}
	class Widget_relation_source_table extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table ){}
	class Widget_chart extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_chart ){}
	class Widget_code_sql extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_code_sql ){}
	class Widget_iframe extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_iframe ){}
	class Widget_viewport_frame extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_viewport_frame ){}
	class Widget_file extends $giper_baza_atom_link.to( ()=> $shm_hitalama_file ){}
	class Widget_app extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_app ){}
	class Widget_custom extends $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_custom ){}
	class Widget_drawing extends $giper_baza_atom_link_to( ()=> $shm_hitalama_map_widget_entity_drawing ){}

	class Widget_render_data_schema extends $mol_schema_record({
		title: $mol_schema_string,
		type: $mol_schema_string,
		text: $mol_schema_string,
		value_refs: $mol_schema_list( $mol_schema_string ),
		body_x: $mol_schema_float,
		body_y: $mol_schema_float,
		right_edge_x: $mol_schema_float,
		bottom_edge_y: $mol_schema_float,
		opacity: $mol_schema_float,
	}) {}

	class Widget_render_data extends $giper_baza_atom.of( Widget_render_data_schema ){}

	export const $shm_hitalama_map_widget_atoms_common = {

		Render_data: Widget_render_data,

		Body_x: $giper_baza_atom_real,
		Body_y: $giper_baza_atom_real,
		Bottom_edge_y: $giper_baza_atom_real,
		Right_edge_x: $giper_baza_atom_real,
		Top_edge_y: $giper_baza_atom_real,
		Left_edge_x: $giper_baza_atom_real,
		Type: Widget_def_type,
		Type_custom: Widget_type_custom,

		Created_at: $giper_baza_atom_real,

		Locked: $giper_baza_atom_bool,

		Hide_head_tools: $giper_baza_atom_bool,

		Map: Widget_map,

		Tags: $giper_baza_list_str,

		Widgets: Widget_widgets,
		Container_widget: Widget_inside_widget,

		Enabled: $giper_baza_atom_bool,

		Data: $giper_baza_atom_dict, //todo: keys for different datas
		Data_method: $giper_baza_atom_text,
		Source_table: Widget_table,

		Description: $giper_baza_atom_text,
		Link_to_viewport: $giper_baza_atom_text,
		Link_url: $giper_baza_atom_text,

	} as const

	export const $shm_hitalama_map_widget_atoms_style = {

		Image: $giper_baza_file,
		Color: $giper_baza_atom_text,
		Font_size: $giper_baza_atom_real,
		Font_family: $giper_baza_atom_text,
		Opacity: $giper_baza_atom_real,
		Background_color: $giper_baza_atom_text,
		Background_opacity: $giper_baza_atom_real,
		Border_color: $giper_baza_atom_text,
		Border_opacity: $giper_baza_atom_real,
		Border_width: $giper_baza_atom_real,
		Border_style: $giper_baza_atom_text,
		Auto_height: $giper_baza_atom_bool,

	} as const

	export const $shm_hitalama_map_widget_atoms_text = {

		Text_atom: $giper_baza_atom_text,
		Text_crdt: Widget_text_crdt,
		Text_crdt_disabled: $giper_baza_atom_bool,
		Text_file: Widget_text_file,
		Link_favicon: $giper_baza_atom_bool,

		Use_text_from: Widget_use_text_from,
		Application_code_customized: $giper_baza_atom_bool,

		/** @deprecated */ Text: $giper_baza_text,

	} as const

	export const $shm_hitalama_map_widget_atoms_connection = {

		Settings_widget: Widget_settings_widget,
		Controlled_widget: Widget_controlled_widget,
		View_widget: Widget_view_widget,
		Code_widget: Widget_code_widget,

	} as const

	export const $shm_hitalama_map_widget_atoms_entities = {

		Ai_request: Widget_ai_request,
		Component: Widget_component,
		Form: Widget_form,
		Form_edit: Widget_form,
		Form_custom: Widget_form_custom,
		Table: Widget_table,
		Dataset: Widget_dataset,
		Entity_field: Widget_entity_field,
		Entity_owner: Widget_entity_owner,
		Record2: Widget_record2,
		Relation_source_record: Widget_relation_source_record,
		Relation_source_field: Widget_relation_source_field,
		Relation_source_table: Widget_relation_source_table,
		Relation_source_row: $giper_baza_atom_real,
		Relation_source_name: $giper_baza_atom_text,
		Chart: Widget_chart,
		Code_sql: Widget_code_sql,
		Iframe: Widget_iframe,
		Viewport_frame: Widget_viewport_frame,
		File: Widget_file,
		App: Widget_app,
		Custom: Widget_custom,
		Drawing: Widget_drawing,

	} as const

	export function $shm_hitalama_map_widget_preprocessed_code( text: string ) {
		const template = text.startsWith( '$'+'value' ) ? '${' + text + '}' : text
		return 'return `'+template+'`'
	}

	export function $shm_hitalama_map_widget_preprocessed_needed( text: string ) {
		return text.startsWith( '$'+'value' ) || text.includes( '${' ) || text.includes( '`' )
	}

	export function $shm_hitalama_map_widget_value_refs( text: string ) {
		const refs = new Set< string >
		const regex = new RegExp( '\\$' + '(?:value|file|widget|data|bind_value)\\s*\\(\\s*[\'"]([^\'"\\n]*)[\'"]', 'g' )
		for( const match of text.matchAll( regex ) ) refs.add( match[1] )
		return [ ... refs ]
	}

	export class $shm_hitalama_map_widget extends $giper_baza_entity.with({

		... $shm_hitalama_map_widget_atoms_common,
		... $shm_hitalama_map_widget_atoms_style,
		... $shm_hitalama_map_widget_atoms_text,
		... $shm_hitalama_map_widget_atoms_connection,
		... $shm_hitalama_map_widget_atoms_entities,

	}){

		render_data_legacy(): typeof Widget_render_data_schema.default {
			return {
				title: super.title() || this.link_str(),
				type: this.type_legacy(),
				text: this.text_legacy(),
				value_refs: $shm_hitalama_map_widget_value_refs( this.text_legacy() ),
				body_x: this.Body_x()?.val() ?? 0,
				body_y: this.Body_y()?.val() ?? 0,
				right_edge_x: this.Right_edge_x()?.val() ?? 0,
				bottom_edge_y: this.Bottom_edge_y()?.val() ?? 0,
				opacity: this.Opacity()?.val() ?? 1,
			}
		}

		@ $mol_mem
		render_data( next?: typeof Widget_render_data_schema.default ) {
			const previous = next === undefined
				? null
				: $mol_wire_sync( this ).render_data_before()
			const data = next !== undefined
				? this.Render_data( null )?.val( next ) ?? Widget_render_data_schema.default
				: this.Render_data()?.val() ?? this.render_data_legacy()

			const map = this.map()
			if( map && previous && next !== undefined ) {
				const before: Record< string, any > = {}
				const after: Record< string, any > = {}
				for( const key of Object.keys( data ) as ( keyof typeof data )[] ) {
					if( $shm_hitalama_map_history.equal( previous[ key ], data[ key ] ) ) continue
					if( $shm_hitalama_map_history.geometry_active( this ) && [
						'body_x', 'body_y', 'right_edge_x', 'bottom_edge_y',
					].includes( key ) ) continue
					before[ key ] = previous[ key ]
					after[ key ] = data[ key ]
				}
				if( Object.keys( before ).length ) $shm_hitalama_map_history.capture( map, {
					type: 'widget_set',
					target: this.link().str,
					before,
					after,
				}, 'Изменение виджета' )
			}
			if( map ) $shm_hitalama_map_journal_recorder.event_add(
				map,
				this,
				data,
				next === undefined ? 'read' : 'write',
			)

			return data
		}

		/** Keep the pre-write snapshot across a suspended history commit. */
		render_data_before() {
			return this.Render_data()?.val() ?? this.render_data_legacy()
		}

		private history_value< Value >(
			property: string,
			before: Value,
			after: Value,
			title = 'Изменение виджета',
		) {
			const map = this.map()
			if( map ) $shm_hitalama_map_history.capture( map, {
				type: 'widget_set',
				target: this.link().str,
				targets: property.endsWith( '_widget' )
					? [ before, after ].filter( value => typeof value === 'string' && value ) as string[]
					: [],
				before: { [ property ]: before },
				after: { [ property ]: after },
			}, title )
			return after
		}

		render_data_patch( next: Partial< typeof Widget_render_data_schema.default > ) {
			if( next.text !== undefined && next.value_refs === undefined ) {
				next = { ... next, value_refs: $shm_hitalama_map_widget_value_refs( next.text ) }
			}
			return this.render_data({ ... this.render_data(), ... next })
		}

		@ $mol_mem
		value_refs() {
			return this.render_data().value_refs
		}

		get title() { return ( next?: string )=> {
			if( next === undefined ) {
				if( this.type() === 'text_md' ) {
					const heading = $shm_hitalama_map_widget_markdown_title( this.render_data().text )
					if( heading ) return heading
				}
				return this.render_data().title || this.link_str()
			}
			this.render_data_patch({ title: next })
			return next
		} }

		widgets( next?: $shm_hitalama_map_widget[] ) {
			const before = next === undefined ? [] : this.Widgets()?.remote_list().map( widget => widget.link().str ) ?? []
			const widgets = this.Widgets(next)?.remote_list( next ) ?? []
			const casted = widgets.map( e => e.cast( $shm_hitalama_map_widget ) )
			if( next === undefined ) return casted.filter( widget => !widget.removed() )
			const after = casted.map( widget => widget.link().str )
			$shm_hitalama_map_history.capture( this.map(), {
				type: 'widget_set',
				target: this.link().str,
				targets: [ ... new Set([ ... before, ... after ]) ],
				before: { widgets: before },
				after: { widgets: after },
			}, 'Изменение состава виджета' )
			return casted
		}

		container_widget( next?: null | $shm_hitalama_map_widget ) {
			if( next === undefined ) return this.Container_widget()?.remote()
			const before = this.Container_widget()?.remote()?.link().str ?? ''
			const result = this.Container_widget( null )?.remote( next ) ?? null
			this.history_value( 'container_widget', before, result?.link().str ?? '' )
			return result
		}

		enabled( next?: boolean | null ) {
			if( next === undefined ) return this.Enabled()?.val()
			const before = this.Enabled()?.val() ?? null
			const result = this.Enabled( next )?.val( next ) ?? null
			return this.history_value( 'enabled', before, result )
		}

		settings_widget( next?: null | $shm_hitalama_map_widget ) {
			if( next === undefined ) return this.Settings_widget()?.remote()!
			const before = this.Settings_widget()?.remote()?.link().str ?? ''
			const result = this.Settings_widget( null )?.remote( next ) ?? null
			this.history_value( 'settings_widget', before, result?.link().str ?? '' )
			return result!
		}

		controlled_widget( next?: null | $shm_hitalama_map_widget ) {
			if( next === undefined ) return this.Controlled_widget()?.remote()!
			const before = this.Controlled_widget()?.remote()?.link().str ?? ''
			const result = this.Controlled_widget( null )?.remote( next ) ?? null
			this.history_value( 'controlled_widget', before, result?.link().str ?? '' )
			return result!
		}

		view_widget( next?: null | $shm_hitalama_map_widget ) {
			if( next === undefined ) return this.View_widget()?.remote()!
			const before = this.View_widget()?.remote()?.link().str ?? ''
			const result = this.View_widget( null )?.remote( next ) ?? null
			this.history_value( 'view_widget', before, result?.link().str ?? '' )
			return result!
		}

		code_widget( next?: null | $shm_hitalama_map_widget ) {
			if( next === undefined ) return this.Code_widget()?.remote()!
			const before = this.Code_widget()?.remote()?.link().str ?? ''
			const result = this.Code_widget( null )?.remote( next ) ?? null
			this.history_value( 'code_widget', before, result?.link().str ?? '' )
			return result!
		}

		code_view_widget() {
			return $shm_hitalama_map_widget_def_code_view_type( this.type() ) !== null
		}

		@ $mol_action
		code_view_widget_open() {
			if( !this.code_view_widget() ) return null

			const exists = this.view_widget()
			if( exists ) {
				if( exists.removed() ) this.map().widget_restore( exists.link() )
				return exists
			}

			const map = this.map()
			const operation = `code-view:${ this.link().str }`
			return map.widget_add_batch( operation, ()=> (
				$shm_hitalama_map_history.transaction( map, 'Открытие связанного виджета', ()=> (
					this.code_view_widget_open_apply()
				), 'user', operation )
			) )
		}

		private code_view_widget_open_apply() {
			const view = this.view_widget()
			const pos = [ this.body_x() + this.right_edge_x() + 10, this.body_y() ]
			const width = Math.max( 600, this.right_edge_x() )
			const height = Math.max( 400, this.bottom_edge_y() )

			if( view ) {
				if( view.removed() ) this.map().widget_restore( view.link() )
				return view
			}

			const view_type = $shm_hitalama_map_widget_def_code_view_type( this.type() )
			if( !view_type ) return null

			const created = this.map().widget_add( view_type, pos, width, height )
			created?.title( 'View: ' + this.title() )
			created?.Use_text_from(null)?.remote( this )
			created?.code_widget( this )
			if( view_type === 'iframe' ) created?.iframe().html_use( true )
			this.view_widget( created )
			return created
		}
		
		settings_widget_enabled( next?: boolean ) {
			const settings = this.settings_widget()
			if( next === undefined ) {
				if( !settings ) return false
				return ! settings.removed()
			}

			return $shm_hitalama_map_history.transaction( this.map(), 'Изменение виджета настроек', ()=> {
				if( next == false ) {
					if( settings ) this.map().widget_cut( settings.link() )
					return false
				}

				const pos = [ this.body_x() + this.right_edge_x() + 10, this.body_y() ]
				let width = 600
				switch (this.type()) {
					case 'chart': width = 300; break;
					case 'echarts': width = 320; break;
					case 'tabulator': width = 320; break;
					case 'table': width = 420; break;
					case 'table2': width = 420; break;
					case 'table_novirt': width = 420; break;
				}

				const height = Math.max(260, this.bottom_edge_y())
				if( settings ) {
					// A previous wire pass may have saved the forward link and suspended
					// before saving the reverse one. Repair it before any further work so
					// the settings widget never leaks into the regular widgets list.
					settings.controlled_widget( this )
					// settings?.Body_x(null)?.val( pos[0] )
					// settings?.Body_y(null)?.val( pos[1] )
					// settings?.Right_edge_x(null)?.val( width )
					// settings?.Bottom_edge_y(null)?.val( height )
					this.map().widget_restore( settings.link() )
				} else {
					const settings_type = $shm_hitalama_map_widget_def_settings_type( this.type() ) ?? 'settings'

					const w = this.map().widget_add( settings_type, pos, width, height )
					this.settings_widget( w )
					w?.controlled_widget(this)
				}
				return true
			}, 'user', `settings:${ this.link().str }:${ next ? 'enable' : 'disable' }` )
		}

		link_str() {
			return this.link().str
		}

		@ $mol_mem
		view( next?: $mol_view ) {
			return next
		}
		
		@ $mol_mem
		map() {
			const reference = this.Map()
			// An explicit empty Map marks a standalone text source, not a legacy
			// widget embedded in a map land. Never invent map/history in its area.
			return reference ? reference.remote() as $shm_hitalama_map : this.land().Data( $shm_hitalama_map )
		}

		@ $mol_mem
		removed() {
			return Boolean( this.map()?.Widgets_removed_list()?.remote_list().find( ( b: $shm_hitalama_map_widget ) => b.link_str() == this.link_str() ) )
		}

		created_at() {
			return this.Created_at()?.val()
		}

		z_descendants(): $shm_hitalama_map_widget[] {
			return this.widgets().flatMap( widget => [ widget, ... widget.z_descendants() ] )
		}

		z_block(): $shm_hitalama_map_widget[] {
			return this.type() == 'group'
				? [ this, ... this.z_descendants() ]
				: [ this ]
		}

		z_move_block( block: readonly $shm_hitalama_map_widget[], target: number ) {
			const list = this.map()?.Widgets_list(null)
			const widgets = ( list?.remote_list() ?? [] ) as $shm_hitalama_map_widget[]
			const block_links = new Set( block.map( ( widget: $shm_hitalama_map_widget ) => widget.link_str() ) )
			const block_ordered = widgets.filter( ( widget: $shm_hitalama_map_widget ) => block_links.has( widget.link_str() ) )
			if( block_ordered.length === 0 ) return widgets

			const target_limited = Math.max( 0, Math.min( target, widgets.length - block_ordered.length ) )
			const next_widgets = widgets.filter( ( widget: $shm_hitalama_map_widget ) => !block_links.has( widget.link_str() ) )
			next_widgets.splice( target_limited, 0, ... block_ordered )

			const first_current = widgets.findIndex( widget => block_links.has( widget.link_str() ) )
			const moving_right = target_limited > first_current
			const moving = moving_right ? [ ... block_ordered ].reverse() : block_ordered

			for( const widget of moving ) {
				const current_widgets = ( list?.remote_list() ?? [] ) as $shm_hitalama_map_widget[]
				const current = current_widgets.findIndex( current_widget => current_widget.link_str() === widget.link_str() )
				const desired = target_limited + block_ordered.findIndex( block_widget => block_widget.link_str() === widget.link_str() )
				if( current < 0 || current === desired ) continue
				list?.move( current, current < desired ? desired + 1 : desired )
			}

			return ( list?.remote_list() ?? [] ) as $shm_hitalama_map_widget[]
		}

		z( next?: number ) {
			const list = this.map()?.Widgets_list( next === undefined ? undefined : null )
			const widgets = ( list?.remote_list() ?? [] ) as $shm_hitalama_map_widget[]
			const current = widgets.findIndex( ( widget: $shm_hitalama_map_widget ) => widget.link_str() === this.link_str() )

			if( next === undefined ) return current < 0 ? 0 : current
			if( current < 0 || widgets.length === 0 ) return 0

			const block = this.z_block()
			const parent = this.container_widget()

			if( parent ) {
				const parent_links = new Set( parent.z_descendants().map( ( widget: $shm_hitalama_map_widget ) => widget.link_str() ) )
				const block_links = new Set( block.map( ( widget: $shm_hitalama_map_widget ) => widget.link_str() ) )
				const parent_indexes = widgets.flatMap( ( widget: $shm_hitalama_map_widget, index: number ) =>
					parent_links.has( widget.link_str() ) ? [ index ] : []
				)

				if( parent_indexes.length === 0 ) return current

				const min = Math.min( ... parent_indexes )
				const max = Math.max( ... parent_indexes ) - block_links.size + 1
				const target = Math.max( min, Math.min( Math.round( next ), max ) )
				this.z_move_block( block, target )
				return this.history_value( 'z', current, target, 'Изменение порядка виджета' )
			}

			const target = Math.max( 0, Math.min( Math.round( next ), widgets.length - block.length ) )
			this.z_move_block( block, target )
			return this.history_value( 'z', current, target, 'Изменение порядка виджета' )
		}

		@ $mol_mem
		css_id() {
			$mol_wire_solid()
			return CSS.escape( this.view()?.dom_id()! )
		}

		text_crdt_disabled( next?: boolean ) {
			return this.Text_crdt_disabled(next)?.val(next) ?? false
		}

		type_legacy() {
			return $shm_hitalama_map_widget_def_type_normalize( this.Type()?.val() )
		}

		text_legacy( next?: string ) {
			if( this.type_legacy() == 'file' ) {
				return this.File()?.remote()?.text() ?? ''
			}

			if( next && next.length > 5000 ) {
				this.text_crdt_disabled( true )
			}
			if( this.text_crdt_disabled() ) {
				return this.Text_atom(next)?.val(next) ?? ''
			}
			
			return this.Text_crdt(next)?.ensure( this.land() )!.value(next) ?? ''
		}

		/** Lifecycle references only: deleting/restoring must not load file contents. */
		file_links(): readonly $giper_baza_link[] {
			return [
				this.type() === 'file' ? this.File()?.remote()?.link() ?? null : null,
				this.Text_file()?.remote()?.link() ?? null,
			].filter( $mol_guard_defined )
		}

		@ $mol_mem
		text( next?: string ): string {
			const stored = this.Text_file()?.remote()
			if( next === undefined ) {
				if( stored ) return $shm_hitalama_file_text_read( stored )
				return this.Render_data()?.val()?.text ?? this.text_legacy()
			}

			const before: string = this.text()
			const map = this.map()
			return $shm_hitalama_map_history.transaction( map, 'Изменение виджета', (): string => {
				// A suspended commit restarts this transaction. The mutation is already done then,
				// while the original captured change remains in the pending transaction.
				if( this.text() === next ) return next

				let replacement: $shm_hitalama_file | null = null
				$shm_hitalama_map_history.silence( ()=> {
					if( $shm_hitalama_file_text_size( next ) > $shm_hitalama_file_text_inline_limit ) {
						replacement = map?.file_make_stable( `widget:${ this.link().str }:${ $mol_hash_string( next ) }` )
							?? this.land().Pawn( $shm_hitalama_file ).Head( this.land().self_make() )
						$shm_hitalama_file_text_write( replacement, next, `${ this.title() || 'widget' }.txt` )
						this.Text_file( null )?.remote( replacement )
						this.render_data_patch({
							text: '',
							value_refs: $shm_hitalama_map_widget_value_refs( next ),
						})
					} else {
						if( next.length > 5000 ) this.text_crdt_disabled( true )
						this.Text_file( null )?.remote( null )
						this.render_data_patch({ text: next })
					}
					if( stored && stored !== replacement ) map?.Files( null )?.cut( stored.link() )
					if( this.type() === 'text_md' ) {
						const heading = $shm_hitalama_map_widget_markdown_title( next )
						if( heading ) this.render_data_patch({ title: heading })
					}
				} )
				$shm_hitalama_map_history.capture( map, {
					type: 'widget_set',
					target: this.link().str,
					before: { text: before },
					after: { text: next },
					meta: { property: 'text' },
				}, 'Изменение виджета' )
				return next
			} )
		}

		link_to_viewport( next?: string ) {
			if( next === undefined ) return this.Link_to_viewport()?.val() ?? ''
			const before = this.Link_to_viewport()?.val() ?? ''
			const result = this.Link_to_viewport( next )?.val( next ) ?? ''
			return this.history_value( 'link_to_viewport', before, result )
		}

		link_url( next?: string ) {
			if( next === undefined ) return this.Link_url()?.val() ?? ''
			const before = this.Link_url()?.val() ?? ''
			const result = this.Link_url( next )?.val( next ) ?? ''
			return this.history_value( 'link_url', before, result )
		}

		description( next?: string ) {
			if( next === undefined ) return this.Description()?.val() ?? ''
			const before = this.Description()?.val() ?? ''
			const result = this.Description( next )?.val( next ) ?? ''
			return this.history_value( 'description', before, result )
		}

		locked( next?: boolean ) {
			if( next === undefined ) return this.Locked()?.val() ?? false
			const before = this.Locked()?.val() ?? false
			const result = this.Locked( next )?.val( next ) ?? false
			return this.history_value( 'locked', before, result )
		}

		hide_head_tools( next?: boolean ) {
			if( next === undefined ) return this.Hide_head_tools()?.val() ?? false
			const before = this.Hide_head_tools()?.val() ?? false
			const result = this.Hide_head_tools( next )?.val( next ) ?? false
			return this.history_value( 'hide_head_tools', before, result )
		}

		tags( next?: readonly string[] ) {
			if( next === undefined ) return ( this.Tags()?.items() ?? [] ) as string[]
			const before = ( this.Tags()?.items() ?? [] ) as string[]
			const result = ( this.Tags( next )?.items( next ) ?? [] ) as string[]
			return this.history_value( 'tags', before, result )
		}
		
		// @ $mol_action
		// tag_add( tag: string ) {
		// 	this.tags( [ tag, ...this.tags() ] )
		// }

		code( next?: string ): string {
			const text_from = this.Use_text_from()?.remote()
			if( text_from ) return text_from.text( next ) ?? ''
			if( this.type() === 'application' ) {
				if( next !== undefined ) return $shm_hitalama_map_history.transaction( this.map(), 'Изменение кода приложения', ()=> {
					const text = this.text( next ) ?? ''
					this.application_code_customized( true )
					return text
				} )
				const text = this.text() ?? ''
				if( text || this.application_code_customized() ) return text
				return this.Type_custom()?.remote()?.source_text( 'default' ) ?? ''
			}

			return this.text( next ) ?? ''
		}

		application_code_customized( next?: boolean ) {
			const before = this.Application_code_customized()?.val() ?? false
			if( next === undefined ) return before
			const after = this.Application_code_customized( null )!.val( next )
			return this.history_value( 'application_code_customized', before, after )
		}

		@ $mol_mem
		data( next?: any ) {
			const method = this.Data_method()?.val()
			if( method ) {
				return this.map().execute( `const next = $${''}next\n${ method }`, { [ '$' + 'next' ]: next, [ '$' + 'this_widget' ]: this } )
			}
			if( next === undefined ) return this.Data()?.val()
			const before = this.Data()?.val() ?? null
			const result = this.Data( next )?.val( next )
			return this.history_value( 'data', before, result )
		}

		@ $mol_mem
		body_x( next?: number ) {
			if( next === undefined ) return this.render_data().body_x
			this.render_data_patch({ body_x: next })
			return next
		}

		@ $mol_mem
		body_y( next?: number ) {
			if( next === undefined ) return this.render_data().body_y
			this.render_data_patch({ body_y: next })
			return next
		}

		@ $mol_mem
		right_edge_x( next?: number ) {
			if( next === undefined ) return this.render_data().right_edge_x
			this.render_data_patch({ right_edge_x: next })
			return next
		}

		@ $mol_mem
		bottom_edge_y( next?: number ) {
			if( next === undefined ) return this.render_data().bottom_edge_y
			this.render_data_patch({ bottom_edge_y: next })
			return next
		}

		@ $mol_mem
		top_edge_y( next?: number ): number {
			const before = $mol_wire_sync( this ).top_edge_y_before()
			if( next === undefined ) return before
			this.Top_edge_y( next )!.val( next )
			if( !$shm_hitalama_map_history.geometry_active( this ) ) this.history_value( 'top_edge_y', before, next )
			return next
		}

		top_edge_y_before() { return this.Top_edge_y()?.val() ?? 0 }

		@ $mol_mem
		left_edge_x( next?: number ): number {
			const before = $mol_wire_sync( this ).left_edge_x_before()
			if( next === undefined ) return before
			this.Left_edge_x( next )!.val( next )
			if( !$shm_hitalama_map_history.geometry_active( this ) ) this.history_value( 'left_edge_x', before, next )
			return next
		}

		left_edge_x_before() { return this.Left_edge_x()?.val() ?? 0 }

		@ $mol_mem
		opacity( next?: number ) {
			if( next === undefined ) return this.render_data().opacity
			this.render_data_patch({ opacity: next })
			return next
		}

		color( next?: string ) {
			if( next === undefined ) return this.Color()?.val() ?? ''
			const before = this.Color()?.val() ?? ''
			const result = this.Color( next )?.val( next ) ?? ''
			return this.history_value( 'color', before, result )
		}

		background_color_default() {
			return $shm_hitalama_map_widget_def_background_default( this.type() )
		}

		background_color( next?: string ): string {
			if( next === undefined ) return this.Background_color()?.val() || this.background_color_default()
			const before = this.background_color()
			const result = this.Background_color( next )?.val( next ) || this.background_color_default()
			return this.history_value( 'background_color', before, result )
		}

		background_opacity( next?: number ): number {
			if( next === undefined ) return this.Background_opacity()?.val() ?? 1
			const before = this.background_opacity()
			const result = this.Background_opacity( next )?.val( next ) ?? 1
			return this.history_value( 'background_opacity', before, result )
		}

		border_color( next?: string ): string {
			if( next === undefined ) return this.Border_color()?.val() ?? 'var(--mol_theme_text)'
			const before = this.border_color()
			const result = this.Border_color( next )?.val( next ) ?? 'var(--mol_theme_text)'
			return this.history_value( 'border_color', before, result )
		}

		border_opacity( next?: number ): number {
			if( next === undefined ) return this.Border_opacity()?.val() ?? 1
			const before = this.border_opacity()
			const result = this.Border_opacity( next )?.val( next ) ?? 1
			return this.history_value( 'border_opacity', before, result )
		}

		border_width( next?: number ): number {
			if( next === undefined ) return this.Border_width()?.val() ?? 0
			const before = this.border_width()
			const result = this.Border_width( next )?.val( next ) ?? 0
			return this.history_value( 'border_width', before, result )
		}

		border_style( next?: string ): string {
			if( next === undefined ) return this.Border_style()?.val() ?? 'solid'
			const before = this.border_style()
			const result = this.Border_style( next )?.val( next ) ?? 'solid'
			return this.history_value( 'border_style', before, result )
		}

		font_size( next?: number ): number {
			if( next === undefined ) return this.Font_size()?.val() ?? 16
			const before = this.font_size()
			const result = this.Font_size( next )?.val( next ) ?? 16
			return this.history_value( 'font_size', before, result )
		}

		font_family( next?: string ): string {
			if( next === undefined ) return this.Font_family()?.val() ?? ''
			const before = this.font_family()
			const result = this.Font_family( next )?.val( next ) ?? ''
			return this.history_value( 'font_family', before, result )
		}

		link_favicon( next?: boolean ): boolean {
			if( next === undefined ) return this.Link_favicon()?.val() ?? true
			const before = this.link_favicon()
			const result = this.Link_favicon( next )?.val( next ) ?? true
			return this.history_value( 'link_favicon', before, result )
		}

		auto_height( next?: boolean ): boolean {
			if( next === undefined ) return this.Auto_height()?.val() ?? false
			const before: boolean = this.auto_height()
			const result = this.Auto_height( next )?.val( next ) ?? false
			return this.history_value( 'auto_height', before, result )
		}

		history_events() {
			return this.map().history_maybe()?.events_for( this ) ?? []
		}

		@ $mol_mem
		type( next?: $shm_hitalama_map_widget_def_type_name ) {
			if( next === undefined ) return $shm_hitalama_map_widget_def_type_normalize( this.render_data().type )
			const type = $shm_hitalama_map_widget_def_type_normalize( next )
			this.render_data_patch({ type })
			return type
		}

		@ $mol_mem
		ai_request() {
			return this.Ai_request(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		component() {
			return this.Component(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		form() {
			const remote = this.Form(null)?.remote()
			if( remote ) return remote

			const form = this.map().Search_statistics(null)?.make( null )!
			this.Form(null)?.remote( form )
			return form
		}

		@ $mol_mem
		chart() {
			const remote = this.Chart(null)?.remote()
			if( remote ) return remote

			const chart = this.map().Charts(null)?.make( this.land() )!
			chart.Widget(null)?.remote( this )
			this.Chart(null)?.remote( chart )
			return chart
		}

		@ $mol_mem
		code_sql() {
			return this.Code_sql(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		viewport_frame() {
			return this.Viewport_frame(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		form_custom() {
			return this.Form_custom(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		dataset() {
			const remote = this.Dataset()?.remote()
			if( remote ) {
				remote.map_bind( this.map() )
				// A remote reference can precede its land. Reading it must not create
				// competing Fields/Records nodes in that still-empty local placeholder.
				// New datasets are initialized below, at their explicit creation site.
				return remote
			}

			const source = this.land()
			const current = this.$.$giper_baza_auth.current().pass()
			const owner = source.king_pass()
			let dataset: $shm_hitalama_map_widget_entity_table2_dataset
			if( owner.lord().str === current.lord().str ) {
				dataset = this.map().Datasets( null )!.make( source )
			} else {
				const public_rank = this.map().access_level() === 'public_edit'
					? this.$.$giper_baza_rank_post( 'just' )
					: source.lord_rank( null )
				const preset: $giper_baza_rank_preset = [[ null, public_rank ]]
				const gifts: Iterable< $giper_baza_unit_gift > = ( source as any )._gift?.values?.() ?? []
				for( const gift of gifts ) {
					const mate = gift.mate()
					if( !mate.str ) continue
					const pass = source.lord_pass( mate )
					if( pass ) preset.push([ pass, gift.rank() ])
				}
				preset.push([ owner, this.$.$giper_baza_rank_rule ])
				dataset = this.map().Datasets( null )!.make( preset )
			}
			this.Dataset( null )?.remote( dataset )
			dataset.map_bind( this.map() )
			dataset.initialize()
			return dataset
		}

		@ $mol_mem
		iframe() {
			return this.Iframe(null)?.ensure( this.land() )!
		}

		@ $mol_mem
		app() {
			const app = this.App(null)?.ensure( this.land() )!
			app.Widget(null)?.remote( this )
			return app
		}

		@ $mol_mem
		drawing() {
			return this.Drawing(null)?.ensure( this.land() )!
		}
		
		@ $mol_mem
		preprocessed( page?: $shm_hitalama_map_page, view?: $mol_view ) {
			const text = this.text()
			if( ! $shm_hitalama_map_widget_preprocessed_needed( text ) ) return text
			const map = this.Map()?.remote()!
			return map.execute( $shm_hitalama_map_widget_preprocessed_code( text ), { [ '$' + 'page' ]: page, [ '$' + 'this_widget' ]: this, [ '$' + 'view' ]: view } )
		}

		@ $mol_mem
		table() {
			const remote = this.Table(null)?.remote()
			if( remote ) {
				if( this.type() === 'table2' ) {
					const dataset = this.dataset()
					if( remote.Dataset()?.remote()?.link().str !== dataset.link().str ) {
						remote.Dataset( null )?.remote( dataset )
					}
				}
				return remote
			}

			const table = this.map().Tables(null)?.make( this.land() )!
			this.Table(null)?.remote( table )
			if( this.type() === 'table2' ) table.Dataset( null )?.remote( this.dataset() )
			return table
		}

		@ $mol_mem
		table_head( next?: any ) {
			return this.table()?.table_head( next )
		}

		@ $mol_mem
		table_col_types( next?: any ) {
			return this.table()?.col_types( next )
		}

		@ $mol_mem
		table_rows( next?: any ) {
			return this.table()?.table_rows( next )
		}

		@ $mol_mem
		table_data( data?: { head: string[], rows: any[][] } ) {
			return this.table()?.table_data( data )
		}

		/** @depcreated */
		@ $mol_mem
		file_str() {
			return this.text()
		}

	}

}
